import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonTriangleLeftSmall = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'triangle left small icon'}</title>
      <polygon points='5,8 10,3 10,13' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
